import cache from "../utils/cacheUtil";
import axiosInstance from "./api";

const MODELS_CACHE_KEY = "models";
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const getCoreModels = async () => {
  const cached = cache.get(MODELS_CACHE_KEY);
  if (cached) return cached;

  try {
    const response = await axiosInstance.get("/api/models/list");
    const models = response?.data?.data || [];
    cache.set(MODELS_CACHE_KEY, models, {
      mode: 'memory',
      absoluteTtl: CACHE_DURATION,
    });
    return models;
  } catch (error) {
    console.error("Error fetching core models:", error);
    throw error;
  }
};

export const testTTS = async (voiceModelId, text, languageCode) => {
  try {
    const response = await axiosInstance.post("/api/chat/audio", {
      voice_model_id: voiceModelId,
      text: text,
      language_code: languageCode,
    }, {
      responseType: 'arraybuffer'  
    });
    const blob = new Blob([response.data], { type: 'audio/mpeg' });
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error testing TTS:", error);
    throw error;
  }
};